module.exports = __webpack_public_path__ + "img/gateway.a9a696bd.svg";